module.exports = __webpack_public_path__ + "static/blog-splash-1-thumbnail-f88dc63b9a69d10579fcf3d7738ffb5d.jpg";